module.exports = __webpack_public_path__ + "images/degarage_small9456e0ee714ada66628cc053dbb847dc.png";